import RelatedCreate from './RelatedCreate';
import RelatedEdit from './RelatedEdit';

const Related: object = {
  create: RelatedCreate,
  edit: RelatedEdit,
};

export default Related;
